import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Text from '@components/Text';

import styles from './styles.module.scss';

function UseInfo() {
    return (
        <Column fullWidth align='center' className={styles.container}>
            <Column className={styles.barcode}
                spacing={4}
                align='center' >
                <CustomBarcode value='1234 5678 9012 3456' />
                <Text>1234 5678 9012 3456</Text>
            </Column>
        </Column>
    );
}
export default UseInfo;
